import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { IrlAPI } from "api/IrlAPI";


export default function IrlTable(props) {

  const [irl, setIrl] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderIrl = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Producto", accessor: "producto", align: "right", width: "100%", },
      { Header: "Valor Unitario", accessor: "valor_unitario", align: "right" },
      { Header: "Frecuencia", accessor: "frecuencia", align: "right" },
      { Header: "DS", accessor: "ds", align: "right" },
      { Header: "Promedio", accessor: "promedio", align: "right" },
      { Header: "Manejo", accessor: "manejo", align: "left", },
      { Header: "Línea", accessor: "linea", align: "left" },
      { Header: "R Línea", accessor: "r_linea", align: "right" },
      { Header: "Xd", accessor: "xd", align: "right" },
      { Header: "DSxd", accessor: "dsxd", align: "right" },
      { Header: "OTCd", accessor: "otcd", align: "right" },
      { Header: "SS", accessor: "ss", align: "right" },
      { Header: "T", accessor: "t", align: "right" },
      { Header: "IRL", accessor: "irl", align: "right" },
      { Header: "INV", accessor: "inv", align: "right" },
      { Header: "MRP", accessor: "mrp", align: "right" },
      { Header: "OP", accessor: "op", align: "right" },
      { Header: "QP", accessor: "qp", align: "right" },
      { Header: "A OP", accessor: "aop", align: "right" },
      { Header: "Detalle", accessor: "detalle", align: "left" },
      { Header: "Nombre Línea", accessor: "nombre_linea", align: "left" },
    ];

    irl.map((element) => {
      rows = [...rows,
      {
        producto: element.producto,
        valor_unitario: currencyformatter.format(Number(element.valor_unitario).toFixed(2)),
        frecuencia: numberFormater.format(Number(element.frecuencia).toFixed(2)),
        ds: numberFormater.format(Number(element.ds).toFixed(2)),
        promedio: numberFormater.format(Number(element.promedio).toFixed(2)),
        manejo: element.manejo,
        linea: element.linea,
        r_linea: element.r_linea,
        xd: numberFormater.format(Number(element.xd).toFixed(2)),
        dsxd: numberFormater.format(Number(element.dsxd).toFixed(2)),
        otcd: numberFormater.format(Number(element.otcd).toFixed(2)),
        ss: numberFormater.format(Number(element.ss).toFixed(2)),
        t: numberFormater.format(Number(element.t).toFixed(2)),
        irl: numberFormater.format(Number(element.irl).toFixed(2)),
        inv: numberFormater.format(Number(element.inv).toFixed(2)),
        mrp: numberFormater.format(Number(element.mrp).toFixed(2)),
        op: numberFormater.format(Number(element.op).toFixed(2)),
        qp: numberFormater.format(Number(element.qp).toFixed(2)),
        aop: numberFormater.format(Number(element.aop).toFixed(2)),
        detalle: element.detalle,
        nombre_linea: element.nombre_linea,
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [irl])

  const calculateIrl = () => {
    return IrlAPI.calculateIrl(true)
      .then(response => {
        setIrl(response.irl)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  const getIrl = (signal) => {
    return IrlAPI.index(signal)
      .then(response => {
        setIrl(response.irl)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  useEffect(() => {
    window.history.replaceState({}, document.title)

    const abortController = new AbortController();
    const signal = abortController.signal

    setLoading(dispatch, true)
    getIrl(signal)

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(calculateIrl)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Calcular IRL'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : irl && renderIrl}
      </MDBox>
    </MDBox>
  )
}